<template>
  <a-modal
    :title="modalTitle"
    :visible="visible"
    :mask-closable="false"
    :width="1400"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-table
      :columns="columns"
      :data-source="arr"
      :loading="loading"
      :scroll="{ x: 1450 }"
      style="padding: 16px 0; background-color: #fff;"
      :row-key="(item, index) => index"
      :pagination="false"
    />
    <a-table
      :columns="columns1"
      :data-source="dataSource1"
      :loading="loading1"
      style="padding: 16px 0; background-color: #fff;"
      :row-key="(item, index) => index"
      :pagination="false"
      :scroll="{ y: 240 }"
      :default-expand-all-rows="true"
    >
      <span
        slot="subsidyAmount"
        slot-scope="text, record"
      >
        <p
          v-if="record.over||record.subsidyAmount < 0"
          style="color: red; margin: 0;"
        >{{ record.subsidyAmount }}</p>
        <p
          v-else
          style="margin: 0;"
        >{{ record.subsidyAmount }}</p>
      </span>

      <template
        slot="startDate"
        slot-scope="startDate"
      >
        {{ moment(startDate).format('YYYY-MM-DD') }}
      </template>

      <span
        v-if="record.subRecordId || record.subRecords.length==0"
        slot="select"
        slot-scope="text, record, recordIndex"
      >
        <a-popconfirm
          title="转移前后配比系数不同，收入确认会发生改变"
          ok-text="确认"
          cancel-text="取消"
          :visible="record.coefVisible"
          @confirm="coefChange(record, visible, recordIndex)"
          @cancel="cancelCoefResource(recordIndex)"
        >
          <a-popconfirm
            title="当前额度不足，是否按照超发策略进行超发"
            ok-text="确认"
            cancel-text="取消"
            :visible="record.popVisible"
            @confirm="confirmPopChange(record, visible, recordIndex)"
            @cancel="cancelPopResource(recordIndex)"
          >
            <a-popconfirm
              title="当前额度不足，是否按照拆分策略进行归属"
              ok-text="确认"
              cancel-text="取消"
              :visible="record.splitVisible"
              @confirm="confirmSplitResource(record, visible, recordIndex)"
              @cancel="cancelSplitResource(recordIndex)"
            >
              <a-select
                v-if="Number(record.subsidyAmount) > 0"
                v-model="record.resourceId"
                placeholder="请选择年度"
                style="width:100%"
                @change="getOperatorYear($event, record, recordIndex)"
              >
                <a-select-option
                  v-for="item in record.operateYearOptions"
                  :key="item.resourceId"
                >
                  {{ item.resourceName }}
                </a-select-option>
              </a-select>
            </a-popconfirm>
          </a-popconfirm>
        </a-popconfirm>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import {
  queryDetailsChange,
  queryAllResource,
  checkChangeOwnership,
  checkChangeOwnershipParent,
  changeOwnershipParent,
  changeOwnershipSubrecord,
  queryPreDetailsChange,
  confirmPre,
  cancelPre
} from '@/api/baseDetail.js'
import moment from 'moment'
import { deepClone } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    baseOptions: {
      type: Array,
      default: null
    },
    initData: {
      type: Object,
      default: null
    },
    resourceId: {
      type: String,
      default: null
    },
    baseId: {
      type: String,
      default: null
    },
    modalTitle: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: '',
        collectionAmount: '',
        collectionDate: '',
        operateYear: '',
        splitVisible: false,
        popVisible: false,
        coefVisible: false
      },
      baseTemp: [],
      loading: false,
      operateYearOptions: [],
      columns: [],
      columns1: [],
      dataSource: [],
      dataSource1: [],
      clonedDataSource1: [],
      dataSource1Tempt: [],
      dataStatistics: [],
      arr: [],
      arrTemp: {},
      rowlen: 0,
      recordId: 0,
      toResourceId: 0,
      innerData1: [],
      count: 0,
      splitCount: 0,
      mark: 1,
      uuid: undefined,
      loading1: true
      // changeFlag: []
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.fetchData()
          // this.fetchSearchOptions()
        }
      }
    }
  },
  methods: {
    moment,
    deepClone,
    async fetchData () {
      this.columns = [
        {
          title: '产品已发总额',
          dataIndex: 'distributionAmount',
          key: 'distributionAmount',
          width: '130px'
        }
      ]
      this.columns1 = [
        {
          title: '产品类型',
          dataIndex: 'productTypeName',
          key: 'productTypeName',
          width: '120px'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          key: 'enterpriseName',
          width: '200px'
        },
        {
          title: '代金券编码',
          dataIndex: 'voucherCode',
          key: 'voucherCode',
          width: '200px'
        },
        {
          title: '补贴金额',
          dataIndex: 'subsidyAmount',
          key: 'subsidyAmount',
          width: '150px',
          scopedSlots: { customRender: 'subsidyAmount' }
        },
        {
          title: '开通时间',
          dataIndex: 'startTime',
          key: 'startTime',
          width: '200px',
          scopedSlots: { customRender: 'startDate' }
        },
        {
          title: '运营年度',
          dataIndex: 'operatorYear',
          key: 'operatorYear',
          scopedSlots: { customRender: 'select' },
          width: '200px'
        }
      ]
      this.loading1 = true

      await queryDetailsChange({
        resourceId: this.resourceId
      }).then((data) => {
        this.uuid = data.uuid
        this.processData(data)
      })
    },
    //
    async fetchPreDate () {
      this.loading1 = true
      await queryPreDetailsChange({
        resourceId: this.resourceId,
        uuid: this.uuid
      }).then((data) => {
        this.processData(data)
      })
    },
    processData (data) {
      this.columns = [
        {
          title: '产品已发总额',
          dataIndex: 'distributionAmount',
          key: 'distributionAmount',
          width: '130px',
          align: 'center'
        }
      ]
      this.columns1 = [
        {
          title: '产品类型',
          dataIndex: 'productTypeName',
          key: 'productTypeName',
          width: '120px',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          key: 'enterpriseName',
          width: '200px',
          align: 'center'
        },
        {
          title: '代金券编码',
          dataIndex: 'voucherCode',
          key: 'voucherCode',
          width: '200px',
          align: 'center'
        },
        {
          title: '补贴金额',
          dataIndex: 'subsidyAmount',
          key: 'subsidyAmount',
          width: '150px',
          scopedSlots: { customRender: 'subsidyAmount' },
          align: 'center'
        },
        {
          title: '开通时间',
          dataIndex: 'startTime',
          key: 'startTime',
          width: '200px',
          scopedSlots: { customRender: 'startDate' },
          align: 'center'
        },
        {
          title: '运营年度',
          dataIndex: 'operatorYear',
          key: 'operatorYear',
          scopedSlots: { customRender: 'select' },
          width: '200px',
          align: 'center'
        }
      ]
      this.dataStatistics = data.dataStatistics
      // columns 表头动态修改
      if (this.dataStatistics.productTypes.length > 0) {
        this.columns.unshift({
          title: data.resourceTypeName,
          dataIndex: 'resourceTypeName',
          key: 'resourceTypeName',
          width: '200px',
          align: 'center'
        })

        this.dataStatistics.productTypes[0].operatorYears.map(
          (resItem, index) => {
            this.columns.splice(index + 2, 1, {
              title: resItem.operatorYear,
              dataIndex: 'operatorYear' + index,
              key: 'operatorYear' + index,
              width: '200px',
              align: 'center'
            })
          }
        )

        this.columns.push({
          title: '剩余额度',
          dataIndex: 'resourcePackRemainAmount',
          key: 'resourcePackRemainAmount',
          width: '200px',
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {}
            }
            obj.attrs.rowSpan = row.baseRowSpan
            return obj
          },
          align: 'center'
        })

        this.arr = []
        // 对详情变更列表数据处理
        const baseRowSpan = this.dataStatistics.productTypes.length // 各自的rowSpan计算出来放入对象
        this.dataStatistics.productTypes.map((resItem, resindex) => {
          const arrTemp = {}
          resItem.operatorYears.map((item, index) => {
            arrTemp.resourceTypeName = resItem.productTypeName

            this.$set(
              arrTemp,
              'distributionAmount',
              resItem.distributionAmount
            ) // 已发总额

            this.$set(
              arrTemp,
              ['operatorYear' + index],
              item.distributionAmount
            ) // 年度发放额度
            arrTemp.baseRowSpan = resindex === 0 ? baseRowSpan : 0 // 各自的rowSpan计算出来放入对象
            arrTemp.resourcePackRemainAmount = this.dataStatistics.resourcePackRemainAmount
            // 资源包剩余额度
          }
          )
          this.arr[resindex] = arrTemp
        })
      }
      // 详情变更下列表
      this.dataSource1Tempt = data.distributionRecords || []
      const productIdArr = []
      if (this.dataSource1Tempt.length > 0) {
        this.dataSource1 = this.renderConstruct(this.dataSource1Tempt)
        this.clonedDataSource1 = this.deepClone(this.dataSource1)
        this.dataSource1.map(async (item, index) => {
          if (!productIdArr.includes(item.productTypeId)) {
            if (index === 0) {
              productIdArr.push(this.dataSource1[0].productTypeId)
            } else {
              productIdArr.push(item.productTypeId)
            }
          }// 去重
          this.$set(this.dataSource1[index], 'splitVisible', false)
          this.$set(this.dataSource1[index], 'popVisible', false)
          this.$set(this.dataSource1[index], 'coefVisible', false)
        })
        this.fetchSearchOptions(this.baseId, productIdArr)
      } else {
        this.dataSource1 = []
      }
      this.loading1 = false
    },
    getOperatorYear (value, record, index) {
      this.recordId = record.recordId
      this.toResourceId = value
      if (record.subRecordId || record.subRecords.length > 0) {
        checkChangeOwnership({
          subRecordId: record.subRecordId,
          toResourceId: record.resourceId,
          uuid: this.uuid,
          resourceId: this.resourceId
        }).then((data) => {
          this.mark = data
          if (data === 1) {
            this.dataSource1[index].splitVisible = false
            this.changeOwenership(record, 1)
          } else if (data === 2) {
            this.dataSource1[index].splitVisible = true
          } else if (data === 3) {
            this.dataSource1[index].splitVisible = false
            this.dataSource1[index].popVisible = true
          } else if (data === 4 || data === 5 || data === 6) {
            this.dataSource1[index].coefVisible = true
          }
        })
      } else {
        checkChangeOwnershipParent({
          recordId: record.recordId,
          toResourceId: record.resourceId,
          uuid: this.uuid,
          resourceId: this.resourceId
        }).then((data) => {
          this.mark = data
          if (data === 1) {
            this.changeOwenership(record, 1)
          } else if (data === 2) {
            this.dataSource1[index].splitVisible = true
          } else if (data === 3) {
            this.dataSource1[index].splitVisible = false
            this.dataSource1[index].popVisible = true
          } else if (data === 4 || data === 5 || data === 6) {
            this.dataSource1[index].coefVisible = true
          }
        })
      }
    },
    cancelSplitResource (index) {
      this.dataSource1[index].popVisible = true
      // this.dataSource1[index].resourceId = this.clonedDataSource1[index].resourceId
    },
    cancelPopResource (index) {
      this.dataSource1[index].popVisible = false
      this.dataSource1[index].splitVisible = false
      this.dataSource1[index].resourceId = this.clonedDataSource1[index].resourceId
    },
    cancelCoefResource (index) {
      this.dataSource1[index].coefVisible = false
      this.dataSource1[index].resourceId = this.clonedDataSource1[index].resourceId
    },
    confirmSplitResource (record, visible, index) {
      this.dataSource1[index].popVisible = false
      this.dataSource1[index].splitVisible = false
      this.changeOwenership(record, 2)
    },
    confirmPopChange (record, visible, index) {
      this.dataSource1[index].popVisible = false
      this.dataSource1[index].splitVisible = false
      this.changeOwenership(record, 3)
    },
    coefChange (record, visible, index) {
      if (this.mark === 4) {
        this.dataSource1[index].coefVisible = false
        this.changeOwenership(record, 1)
      } else if (this.mark === 5) {
        this.dataSource1[index].coefVisible = false
        this.dataSource1[index].splitVisible = true
      } else if (this.mark === 6) {
        this.dataSource1[index].coefVisible = false
        this.dataSource1[index].popVisible = true
      }
    },
    changeOwenership (record, mark) {
      if (record.subRecordId || record.subRecords.length > 0) {
        changeOwnershipSubrecord({
          recordId: record.subRecordId,
          toResourceId: record.resourceId,
          mark: mark,
          uuid: this.uuid,
          resourceId: this.resourceId
        }).then((data) => {
          if (data) {
            this.$message.success('子记录调整成功!')
            // this.changeFlag.push(1)
            this.clonedDataSource1 = this.deepClone(this.dataSource1)
            this.fetchPreDate()
          }
        })
      } else {
        changeOwnershipParent({
          recordId: record.recordId,
          toResourceId: record.resourceId,
          mark: mark,
          uuid: this.uuid,
          resourceId: this.resourceId
        }).then((data) => {
          if (data) {
            this.$message.success('调整成功!')
            // this.changeFlag.push(1)
            this.clonedDataSource1 = this.deepClone(this.dataSource1)
            this.fetchPreDate()
          }
        })
      }
      // this.fetchPreDate()
    },
    // 获取下拉选择数据源
    fetchSearchOptions (baseId, productIdArr) {
      this.loading = true
      queryAllResource({
        baseId: baseId,
        productTypeIds: productIdArr
      }).then(async (data) => {
        this.loading1 = true
        const operateYearOptions = data
        Object.keys(operateYearOptions).forEach((key) => {
          this.dataSource1.map(async (item, index) => {
            if (Number(key) === Number(item.productTypeId)) {
              this.dataSource1[index].operateYearOptions = operateYearOptions[key]
            }
          })
        })
        this.loading1 = false
      })
      this.loading = false
    },
    handleCancel () {
      cancelPre({
        resourceId: this.resourceId,
        uuid: this.uuid
      }).then((data) => {
        this.$emit('cancel')
      })
    },
    handleOk () {
      // const isChangeFlag = this.changeFlag.some(item => {
      //   return item === 1
      // })
      // if (isChangeFlag) {
      confirmPre({
        resourceId: this.resourceId,
        uuid: this.uuid
      }).then(() => {
        this.$message.success('确认调整!')
        this.$emit('ok')
        // this.changeFlag = []
      })
      // } else {
      //   this.$emit('cancel')
      // }
    },
    renderConstruct (tree) {
      // 树结构目录处理为同级
      const arr = []
      for (let i = 0; i < tree.length; i++) {
        const stack = []
        stack.push(tree[i])
        while (stack.length) {
          const node = stack.pop()
          arr.push(node)
          if (node.subRecords) {
            // 判断当前节点是否展开 展开则将子节点加入数组
            for (let j = node.subRecords.length - 1; j >= 0; j--) {
              node.subRecords[j].startTime = node.startTime
              stack.push(node.subRecords[j])
            }
          }
        }
      }
      return arr
    }
  }
}
</script>

<style lang="less" scoped>
</style>
